// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1kq5m","location":"Header_location__2nLYw"};